import { inlineErrorEvent } from './common';

export const languageUpdateError = inlineErrorEvent('language preferences update');
